import React, { useEffect } from 'react';
import { IconX } from '@tabler/icons-react';

/**
 * The site-standard modal. Use everywhere a dialog is needed.
 *
 * <Modal title="Invite to Group" icon={IconMailForward} onClose={...}
 *        footer={<>
 *          <button className="uu-modal2-cancel" onClick={onClose}>Cancel</button>
 *          <button className="uu-submit-btn">Send</button>
 *        </>}>
 *   ...body content...
 * </Modal>
 *
 * - size: 'sm' (400px) | 'md' (520px, default) | 'lg' (680px)
 * - footer buttons are right-aligned and never overflow; body scrolls if tall
 * - closes on overlay click and Escape
 */
const Modal = ({ title, icon: Icon, size = 'md', onClose, footer, children }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <section className="uu-modal2-overlay" onClick={onClose}>
      <section
        className={`uu-modal2 uu-modal2--${size}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="uu-modal2-head">
          <span className="uu-modal2-title">
            {Icon && <span className="uu-modal2-title-icon"><Icon size={17} stroke={2} /></span>}
            {title}
          </span>
          <button className="uu-modal2-close" onClick={onClose} aria-label="Close">
            <IconX size={18} stroke={2} />
          </button>
        </header>

        <section className="uu-modal2-body">
          {children}
        </section>

        {footer && (
          <footer className="uu-modal2-foot">
            {footer}
          </footer>
        )}
      </section>
    </section>
  );
};

export default Modal;
